/**
 * 将数字保留到小数点后 8 位。
 * @param value 输入数字。
 * @returns 保留 8 位小数后的数字。
 */
export function roundToEightDecimalPlaces(value: number): number {
    return Number(value.toFixed(8));
}
